import { css, Theme } from "@emotion/react";

export const root = (theme: Theme) =>
    css({
        ...theme.candy.typography.primary.css(),
        position: "relative",
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        overflow: "hidden",
        zIndex: 0,
    });
